import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#one-cikanlar", label: "Öne Çıkanlar" },
  { href: "#manifesto", label: "Manifesto" },
  { href: "#koleksiyon", label: "Koleksiyon" },
  { href: "#iletisim", label: "İletişim" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl border-b border-stone-200/60"
          : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-serif text-2xl md:text-3xl tracking-tight text-stone-900">
          İnegöl <span className="text-wood-light">Mobilya</span>
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="link-underline text-xs font-semibold tracking-[0.2em] uppercase text-stone-600 hover:text-stone-900 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          className="md:hidden text-stone-800"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-white/90 backdrop-blur-xl border-b border-stone-200 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              className="text-sm font-semibold tracking-[0.2em] uppercase text-stone-700"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </motion.header>
  );
};
